/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';

import { Error } from 'Components/molecules/Error';

// Taken directly from React's docs
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('something went wrong with the component', this.props);
  }

  render() {
    const { hasError } = this.state;
    const { children, forOrganism } = this.props;
    if (hasError) {
      if (forOrganism) return <Error />;
      return <h1>Something went wrong.</h1>;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
  forOrganism: PropTypes.bool,
};

ErrorBoundary.defaultProps = {
  children: [],
  forOrganism: false,
};

export default ErrorBoundary;
